import PropTypes from 'prop-types';
import { MasterCategoryTab } from './MasterCategoryTab';
import { pCategoriesOf, addPCategory, updatePCategory, deletePCategory } from '../../data/store';
import { useSharedStore } from '../../hooks/useSharedStore';
export const PCategoryTab = ({ org, showNotification }) => {
  useSharedStore();
  return (
    <MasterCategoryTab
      org={org}
      title="P-Categories"
      singular="P-Category"
      list={() => pCategoriesOf(org.id)}
      onCreate={addPCategory}
      onUpdate={updatePCategory}
      onDelete={deletePCategory}
      showNotification={showNotification}
    />
  );
};

PCategoryTab.propTypes = {
  org: PropTypes.object.isRequired,
  showNotification: PropTypes.func,
};
